if (!customElements.get("scrolling-text-banner")) {
  customElements.define(
    "scrolling-text-banner",
    class ScrollingTextBanner extends HTMLElement {
      constructor() {
        super();
        this.spacing = 20;
        this.speed = 100;
        this.mobileBreakpoint = 600;
        this.mobileSpeedFactor = 0.7;
        this.resizeObserver = null;
        this.pauseOnHover = false;
        this.isPaused = false;
      }

      connectedCallback() {
        this.spacing = parseInt(this.getAttribute("data-spacing")) || this.spacing;

        const speedInput = parseInt(this.getAttribute("data-speed")) || 5;
        this.speed = this.mapSpeed(speedInput);

        this.mobileSpeedFactor =
          parseFloat(this.getAttribute("data-mobile-speed-factor")) || this.mobileSpeedFactor;

        this.initializeScrollingText();
        this.observeResizing();
      }

      disconnectedCallback() {
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
        this.removeEventListeners();
      }

      mapSpeed(input) {
        const minSpeed = 30;
        const maxSpeed = 300;
        return minSpeed + (maxSpeed - minSpeed) * ((input - 1) / 9);
      }

      getAdjustedSpeed() {
        return window.innerWidth < this.mobileBreakpoint
          ? this.speed * this.mobileSpeedFactor
          : this.speed;
      }

      initializeScrollingText() {
        const heroTitle = this.querySelector(".hero__title");
        if (!heroTitle) {
          console.error("No `.hero__title` element found.");
          return;
        }

        this.pauseOnHover = heroTitle.getAttribute("data-pause-on-hover") === "true";

        const originalHTML = heroTitle.innerHTML.trim();
        if (!originalHTML) {
          console.error("No content found inside `.hero__title`.");
          return;
        }

        heroTitle.innerHTML = "";

        const scrollingContainer = document.createElement("div");
        scrollingContainer.classList.add("scrolling-container");
        heroTitle.appendChild(scrollingContainer);

        for (let i = 0; i < 2; i++) {
          const wrapper = document.createElement("div");
          wrapper.classList.add("scrolling-wrapper");

          for (let j = 0; j < 10; j++) {
            const textWrapper = document.createElement("div");
            textWrapper.classList.add("scrolling-text");
            textWrapper.innerHTML = originalHTML;
            textWrapper.style.marginRight = `${this.spacing}px`;
            wrapper.appendChild(textWrapper);
          }

          scrollingContainer.appendChild(wrapper);
        }

        this.setAnimationSpeed(scrollingContainer);

        // Set up listeners
        if (this.pauseOnHover) {
          this.setupPauseBehavior();
        }
      }

      setAnimationSpeed(scrollingContainer) {
        requestAnimationFrame(() => {
          const wrappers = scrollingContainer.querySelectorAll(".scrolling-wrapper");
          if (wrappers.length !== 2) return;

          const wrapperWidth = wrappers[0].offsetWidth;
          const adjustedSpeed = this.getAdjustedSpeed();
          const duration = wrapperWidth / adjustedSpeed;

          scrollingContainer.style.width = `${wrapperWidth * 2}px`;
          wrappers.forEach((wrapper, index) => {
            wrapper.style.animationDuration = `${duration}s`;
            wrapper.style.animationDelay = `${-index * duration}s`;
            wrapper.style.animationPlayState = this.isPaused ? "paused" : "running";
          });
        });
      }

      pauseScrolling() {
        const wrappers = this.querySelectorAll(".scrolling-wrapper");
        wrappers.forEach(wrapper => {
          wrapper.style.animationPlayState = "paused";
        });
        this.isPaused = true;
      }

      resumeScrolling() {
        const wrappers = this.querySelectorAll(".scrolling-wrapper");
        wrappers.forEach(wrapper => {
          wrapper.style.animationPlayState = "running";
        });
        this.isPaused = false;
      }

      toggleScrolling() {
        if (this.isPaused) {
          this.resumeScrolling();
        } else {
          this.pauseScrolling();
        }
      }

      setupPauseBehavior() {
        this.removeEventListeners(); // Prevent duplicates

        if (window.innerWidth < this.mobileBreakpoint) {
          // Mobile → click to toggle
          this.addEventListener("click", this.toggleScrollingBound = this.toggleScrolling.bind(this));
        } else {
          // Desktop → hover to pause
          this.addEventListener("mouseenter", this.pauseScrollingBound = this.pauseScrolling.bind(this));
          this.addEventListener("mouseleave", this.resumeScrollingBound = this.resumeScrolling.bind(this));
        }
      }

      removeEventListeners() {
        if (this.toggleScrollingBound) {
          this.removeEventListener("click", this.toggleScrollingBound);
        }
        if (this.pauseScrollingBound) {
          this.removeEventListener("mouseenter", this.pauseScrollingBound);
        }
        if (this.resumeScrollingBound) {
          this.removeEventListener("mouseleave", this.resumeScrollingBound);
        }
      }

      observeResizing() {
        const heroTitle = this.querySelector(".hero__title");
        if (!heroTitle) return;

        this.resizeObserver = new ResizeObserver(() => {
          this.recalculateAnimation();
          this.setupPauseBehavior(); // Rebind correct listeners on resize
        });
        this.resizeObserver.observe(heroTitle);
      }

      recalculateAnimation() {
        const scrollingContainer = this.querySelector(".scrolling-container");
        if (scrollingContainer) {
          this.setAnimationSpeed(scrollingContainer);
        }
      }
    }
  );
}
